module.exports = __webpack_public_path__ + "img/xuexiao.029bc32d.png";